var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    viewBox: "0 0 40 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.100098 23.1H18.6001V0H0.100098V23.1ZM1.7001 1.6H16.9001V21.4H1.7001V1.6Z",
    fill: "#182F88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8 0V23.1H39.3V0H20.8ZM37.6 21.4H22.4V1.6H37.6V21.4V21.4Z",
    fill: "#182F88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 47.9999H18.5V24.8999H0V47.9999ZM1.6 26.5999H16.8V46.3999H1.6V26.5999Z",
    fill: "#182F88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6001 47.9999H39.1001V24.8999H20.6001V47.9999ZM22.3001 26.5999H37.5001V46.3999H22.3001V26.5999Z",
    fill: "#182F88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9585 34.147L5.32178 41.7837L6.02888 42.4908L13.6656 34.8541L12.9585 34.147Z",
    fill: "#182F88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6879 39.3746L9.93018 42.1323L10.6373 42.8394L13.395 40.0817L12.6879 39.3746Z",
    fill: "#182F88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61794 33.1216L7.35522 35.3843L8.06232 36.0914L10.325 33.8287L9.61794 33.1216Z",
    fill: "#182F88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0954 7.06791L25.4587 14.7046L26.1658 15.4117L33.8025 7.77501L33.0954 7.06791Z",
    fill: "#182F88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0028 9.43274L32.2451 12.1904L32.9522 12.8975L35.7099 10.1398L35.0028 9.43274Z",
    fill: "#182F88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7207 9.60154L24.458 11.8643L25.1651 12.5714L27.4278 10.3086L26.7207 9.60154Z",
    fill: "#182F88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.4fd19d4d.svg";
export { ForwardRef as ReactComponent };